<template>
  <table class="expense-details-body-table">
    <thead>
      <tr class="for-large-screens">
        <th>Date</th>
        <th>Is Unit</th>
        <th>Unit Price</th>
        <th>Quantity</th>
        <th>$Amount</th>
        <th>Note</th>
        <th></th>
      </tr>
      <tr>
        <th colspan="7" class="for-small-screens">
          Expense Details
        </th>
      </tr>
    </thead>

    <tbody>
      <ExpenseEntry
        v-for="(entry, idx) in entries"
        :key="entry.id"
        :value="entry"
        :can-edit="canEdit"
        :start-date="expense.startDate"
        :end-date="expense.endDate"
        @entryChange="onEntryChange(idx, $event)"
        @removeEntry="removeEntry(idx)"
      />
    </tbody>

    <tfoot>
      <tr class="for-large-screens">
        <th>Total</th>
        <th />
        <th />
        <th />
        <th>$&nbsp;{{ grandTotal }}</th>

        <th>
          <textarea v-if="canEdit" v-model="expenseNote" rows="3" @change="onChange()" />
          <span v-else>{{ expenseNote }}</span>
        </th>
        <th />
      </tr>
      <tr class="for-small-screens">
        <th>Total</th>
        <th>$&nbsp;{{ grandTotal }}</th>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import * as R from 'ramda';
import ExpenseEntry from './ExpenseEntry';

export const sumExpenses = entries => {
  let totalExpenses = 0;
  R.map(entry => {
    totalExpenses += parseFloat(entry.amount);
  })(entries);
  return totalExpenses.toFixed(2);
};

export default {
  name: 'ExpenseDetailsTable',
  components: {
    ExpenseEntry
  },
  props: {
    expense: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      entries: [],
      expenseNote: ''
    };
  },
  computed: {
    grandTotal() {
      return sumExpenses(this.entries);
    }
  },
  watch: {
    expense: {
      immediate: true,
      handler() {
        this.expenseNote = this.expense.expenseNote;
        if (this.expense.expenseEntries !== undefined) {
          this.entries = R.clone(this.expense.expenseEntries);
        }
      }
    }
  },
  methods: {
    onEntryChange(idx, entry) {
      this.$set(this.entries, idx, entry); // Vue.js Caviet per https://vuejs.org/v2/guide/list.html#Caveats
      this.onChange();
    },
    removeEntry(idx) {
      this.$emit('removeTableEntry', idx);
    },
    onChange() {
      this.$emit('change', {
        entries: this.entries,
        totalAmount: this.grandTotal,
        expenseNote: this.expenseNote
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.expense-details-body-table {
  border-collapse: collapse;
  table-layout: fixed;

  textarea {
    width: 100%;
    font-size: inherit;
  }

  td,
  th {
    padding: 5px;
  }

  thead {
    background-color: $background-level-3;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.18px;
    line-height: 21px;
    tr {
      border-top: 20px solid $background-level-3;
      border-bottom: 20px solid $background-level-3;
    }
  }

  tbody {
    background-color: $background-level-2;
    border-top: 10px;
    font-size: 16px;
  }

  tr th:first-child {
    padding-left: $details-padding;
  }
  tr th:last-child {
    padding-right: $details-padding;
  }

  tfoot {
    background-color: $background-level-3;
    tr th {
      padding-top: 10px;
      padding-bottom: 10px;
      &:first-of-type {
        width: 40%;
      }
    }
  }
  .for-small-screens {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .expense-details-body-table {
    * {
      font-size: 0.8rem;
    }
    thead {
      tr {
        border-top: 10px solid $background-level-3;
        border-bottom: 10px solid $background-level-3;
      }
    }
    tbody {
      tr td {
        padding-top: 5px;
        padding-bottom: 5px;
      }
    }

    tr th:first-child,
    tr td:first-child {
      padding-left: $responsive-details-padding;
    }
    tr th:last-child,
    tr td:last-child {
      padding-right: $responsive-details-padding;
    }
    .hide-on-mobile {
      display: none;
    }

    .for-large-screens {
      display: none !important;
    }
    .for-small-screens {
      display: flex !important;
      width: 85vw !important;
    }
  }
}
</style>
